import * as angular from 'angular';
import { ChatService } from './ChatService';
// import login from '../login';
export default angular
    .module('chat', [])
    .run(['$rootScope', 'ChatService', 'AuthenticationService', function ($rootScope, ChatService, AuthenticationService) {
        $rootScope.$on('$stateChangeSuccess', function (e, toState, toParams) {
            if (toState.name.startsWith('auth')) {
                if (!ChatService.built) {
                    ChatService.build();
                }
            }
            else {
                if (ChatService.built) {
                    ChatService.destroy();
                }
            }
        });
    }])
    .service('ChatService', ChatService).name;
